import * as keystore from "./keystore";

let access: {
  token: string;
  expiresAt: number;
  scopes: string[] | null;
} | null = null;
let generation = 0;
export const version = () => generation;

export function accessToken(): string | null {
  return access && access.expiresAt > Date.now() + 10_000 ? access.token : null;
}
export function accessScopes(): string[] | null {
  return access?.scopes ?? null;
}

export async function setTokens(
  response: {
    access_token: string;
    expires_in: number;
    refresh_token?: string;
    scope?: string;
  },
  expected = generation,
) {
  if (expected !== generation) return;
  access = {
    token: response.access_token,
    expiresAt: Date.now() + response.expires_in * 1000,
    scopes: response.scope?.split(" ").filter(Boolean) ?? null,
  };
  if (response.refresh_token)
    await keystore.put("refresh_token", response.refresh_token);
}

export function clear(): void {
  access = null;
}

export async function signOut(): Promise<void> {
  generation++;
  access = null;
  await keystore.clear();
}

export const refreshToken = () => keystore.get<string>("refresh_token");
